export default __webpack_public_path__ + "static/media/PayPal_logo_logotype_emblem.c60e83c9.svg";